var render = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.autoShow || _vm.show)?_c('div',{staticClass:"download-progress progress position-relative",staticStyle:{"background-color":"rgba(0, 0, 0, 0.20)"}},[_c('div',{class:['progress-bar', ( _obj = {}, _obj[("bg-" + (_vm.colors.background))] = _vm.autoColor, _obj )],style:({ width: _vm.progressWidthPercent }),attrs:{"aria-valuemax":"100","aria-valuemin":"0","aria-valuenow":_vm.download ? _vm.download.progress : 0,"role":"progressbar"}}),_c('div',{class:[
			'h-100',
			'position-absolute',
			'text-center',
			( _obj$1 = {}, _obj$1[("text-" + (_vm.colors.foreground))] = _vm.autoColor, _obj$1 ),
			'w-100' ]},[_vm._t("default")],2)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }